/**
 * O handle da oferta de voo NÃO existe mais na sessão modal (409 `offer_stale`
 * do BFF, #2332) — re-tentar o MESMO fetch nunca resolve; o caminho de
 * recuperação é uma nova busca. Compartilhado entre o data layer do web-chat
 * (que o lança no 409 de `/flight/tariff` e `/flight/legs`) e o genui-kit (que
 * o discrimina para renderizar o estado `stale` da escada de tarifas) — UMA
 * classe, senão o `instanceof` entre os dois pacotes mente.
 *
 * NÃO é `RequestError`: como o `CustomerApiError`, modela uma falha OUTBOUND
 * vista pelo cliente, não a superfície HTTP inbound.
 */
export class FlightOfferStaleError extends Error {
  constructor() {
    super('flight offer handle is stale (409 offer_stale)');
    this.name = 'FlightOfferStaleError';
  }
}
